// extracted by mini-css-extract-plugin
module.exports = {"Content":"Rating_Content__AXfO-"};